import React, { useEffect, useState, useRef } from "react";
import { DataTable, DataTableExpandedRows, DataTableRowEvent, DataTableValueArray } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import { Toast } from "primereact/toast";
import activityServices from "../../services/activityServices";

interface Activity {
  p_activityid: number;
  p_activityname: string;
  p_description: string;
  p_duration: string | null;
  p_isactive: boolean;
}

const ActivityTable = (props: any) => {
  const [selectedActivity, setSelectedActivity] = useState<Activity[]>([]);
  const [expandedRows, setExpandedRows] = useState<DataTableExpandedRows | DataTableValueArray | undefined>(undefined);
  const [loading, setLoading] = useState<boolean>(false);
  const toast = useRef<Toast>(null);
  const [totalRecordsActivity, setTotalRecordsActivity] = useState<number>(0);

  const EditActivity = (rowData: Activity) => {
    props.onEditActivityClicked(rowData);
  };

  const onDeleteClick = async (data: Activity) => {
  
    const activityId = {
      activityid: data.p_activityid,
    };
    confirmDialog({
      message: `Are you sure you want to delete Activity?`,
      header: "Confirm delete Activity",
      icon: "pi pi-exclamation-triangle",
      accept: () => onActivityDelete(activityId)
    });
  };

  const onActivityDelete = async (activityId: any) => {
    setLoading(true);
    await activityServices.DeleteActivity(activityId)
      .then((res: any) => {
        if (res.data.p_response) {
          toast.current?.show({ severity: "success", summary: "Success", detail: res.data.p_msg, life: 3000 });
          GetActivity();
        } else {
          toast.current?.show({ severity: "warn", summary: "Warning", detail: res.data.p_msg, life: 3000 });
          
        }
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        console.error("DeleteActivity error:", error);
        toast.current?.show({ severity: "error", summary: "Error", detail: "Something went wrong", life: 3000 });
      });
  };

  const verifiedBodyTemplate = (rowData: Activity) => {
    return (
      <React.Fragment>
        <Button className="table-button custome-icon edit-icon" onClick={() => EditActivity(rowData)} tooltip="Edit" />
        <Button className="table-button custome-icon delete-icon" onClick={() => onDeleteClick(rowData)} tooltip="Delete"></Button>
      </React.Fragment>
    );
  };

  const onRowExpand = (event: DataTableRowEvent) => {
    setExpandedRows(event.data);
  };

  const rowExpansionTemplate = (data: Activity) => {
    return (
      <div className="p-3">
        <h5>Orders for {data.p_activityname}</h5>
      </div>
    );
  };

  useEffect(() => {
    setLoading(true);
    GetActivity();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    GetActivity();
  }, [props.reloadActivityGrid]);

  const GetActivity = () => {
    const data = {
      activityid: null,
      poiid: null,
    };

    activityServices.GetActivity(data)
      .then((res: any) => {
        setLoading(true);
        if (res.status === 200) {
          setSelectedActivity(res.data);
          setTotalRecordsActivity(res.data.length);
          props.setActivityDataFilter(res.data);
          setLoading(false);
        } else {
          setLoading(false);
          toast.current?.show({ severity: "warn", summary: "Warning", detail: "Failed to fetch activities", life: 3000 });
        }
      })
      .catch((error) => {
        setLoading(false);
        console.error("GetActivity error:", error);
        toast.current?.show({ severity: "error", summary: "Error", detail: "Something went wrong", life: 3000 });
      });
  };

  const SrNo = (rowData: any, index: any) => {
    return (
      <div className="flex align-items-center gap-2">
        <span>{ index.rowIndex + 1}</span>
      </div>
    );
  };

  const Status = (rowData: Activity) => {
    return (
      <div className="flex align-items-center gap-2">
        <span>{rowData.p_isactive ? "Active" : "Inactive"}</span>
      </div>
    );
  };

  return (
    <div className="table-section">
      <Toast ref={toast} />
      <DataTable
        value={props.filteredActivityData}
        //  value={selectedActivity}
        dataKey="p_activityid"
        scrollHeight="600px"
        paginator rows={15}
        loading={loading}
        emptyMessage="No Activity found."
        onRowExpand={onRowExpand}
        expandedRows={expandedRows}
        onRowToggle={(e) => setExpandedRows(e.data)}
        rowExpansionTemplate={rowExpansionTemplate}
      >
        <Column field="srNo" header="Sr. No." style={{ minWidth: "3rem" }} body={SrNo} />
        <Column field="p_activityname" header="Activity name" style={{ minWidth: "12rem" }} sortable />
        <Column field="p_description" header="Description" style={{ minWidth: "12rem" }} sortable />
        <Column field="p_duration" header="Duration" style={{ minWidth: "12rem" }} sortable />
        <Column field="p_isactive" header="Status" body={Status} sortable />
        <Column field="Action" header="Action" style={{ minWidth: "6rem" }} body={verifiedBodyTemplate} />
      </DataTable>
    </div>
  );
};

export default ActivityTable;